import { useContext, type Dispatch } from 'react';
import type { BuilderAction, BuilderState, CharacterDraft } from '../types';
import { BuilderContext } from './builderContextValue';

/**
 * Hooks consumer del `BuilderContext`.
 *
 * Vivono in un file separato dal Provider per soddisfare
 * `react-refresh/only-export-components` (Fast Refresh richiede che un
 * file con component export esporti solo componenti).
 */

export function useBuilderState(): BuilderState {
  const ctx = useContext(BuilderContext);
  if (!ctx) throw new Error('useBuilderState: deve essere usato dentro <BuilderProvider>');
  return ctx.state;
}

export function useBuilderDispatch(): Dispatch<BuilderAction> {
  const ctx = useContext(BuilderContext);
  if (!ctx) throw new Error('useBuilderDispatch: deve essere usato dentro <BuilderProvider>');
  return ctx.dispatch;
}

export function useResetBuilder(): () => void {
  const ctx = useContext(BuilderContext);
  if (!ctx) throw new Error('useResetBuilder: deve essere usato dentro <BuilderProvider>');
  return ctx.resetBuilder;
}

export function useBuilderDraft(): CharacterDraft {
  return useBuilderState().draft;
}
